import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: "Home",
    component: () => import("../views/Home/Home.vue"),
    meta: {
      metaInfo: {
        title: "Fusteel Co., Ltd.",
        keywords: "home",
        description: "Home:Fusteel(also searched as FusteelX) provides the highest quality service and the best stainless steel rebars, steel strands, dowel bars and so on.We are world's leading functional steel solution provider,and stainless steel rebar producer."
      }
    },
  },
  {
    path: "/others",
    name: "Others",
    component: () => import("../views/Others/Others.vue"),
    meta: {
      metaInfo: {
        title: "Other Non-Magnetic Products - Fusteel Co., Ltd.",
        keywords:
          "non-magnetic steel plate, non-magnetic spring, non-magnetic coupler, non-magnetic welding wire, non-magnetic steel pipe, non-magnetic tube",
        description:
          "Fusteel (also searched as FusteelX) provides a wide range of high-performance non-magnetic products, including non-magnetic steel plates, springs, couplers, welding wires, steel pipes and tubes. Designed for applications requiring extremely low magnetic permeability, high strength and excellent corrosion resistance, our products are widely used in fusion energy, semiconductor manufacturing, medical equipment, defense and other precision engineering industries."
      }
    },
  },
  {
    path: "/non-magnetic-rebar",
    name: "non-magnetic-rebar",
    component: () => import("../views/NonMagneticRebar/NonMagneticRebar.vue"),
    meta: {
      metaInfo: {
        title: "Non-Magnetic Rebar HRB400NM/HRB500NM - Fusteel Co., Ltd.",
        keywords:
          "non magnetic rebar, HRB400NM,HRB500NM, non-magnetic steel rebar, zero magnetic rebar, low magnetic permeability rebar, fusion energy rebar, semiconductor construction rebar",
        description:
          "Non-Magnetic Rebar(HRB400NM/HRB500NM):FusteelX is a professional manufacturer of ultra-low magnetic permeability reinforcement steel. FusteelX® Non-Magnetic Rebar is designed for fusion energy facilities, semiconductor manufacturing platforms, magnetic shielding structures and other applications requiring strict control of magnetic interference. With relative magnetic permeability ≤ 1.002 and residual magnetism ≤ 1 nT after magnetization to 300 Gauss, our non-magnetic rebars provide excellent magnetic stability, high strength and outstanding corrosion resistance."
      }
    },
  },
  {
    path: "/non-magnetic-fastener",
    name: "non-magnetic-fastener",
    component: () => import("../views/NonMagneticFastener/NonMagneticFastener.vue"),
    meta: {
      metaInfo: {
        title: "Non-Magnetic Fasteners NMS-80/NMS-100 - Fusteel Co., Ltd.",
        keywords:
          "non magnetic fasteners, non-magnetic bolts, NMS-80/NMS-100 fasteners, zero magnetic fasteners, non-magnetic stainless steel fasteners, low magnetic permeability fasteners, fusion energy fasteners",
        description:
          "Non-Magnetic Fasteners:NMS-80/NMS-100 non-magnetic Fasteners manufactured by Fusteel Co., Ltd. are engineered for extreme electromagnetic environments, including fusion energy facilities, MRI systems, mine countermeasure vessels (MCMVs), semiconductor manufacturing equipment and other magnetically sensitive applications. With relative magnetic permeability ≤ 1.002 and residual magnetism ≤ 1 nT after magnetization to 300 Gauss, NMS-80/NMS-100 fasteners provide stable zero-magnetic performance, high mechanical strength, corrosion resistance and long-term durability for demanding marine, high-salinity and high-humidity environments."
      }
    },
  },
  {
    path: "/X55Ni40-Ultra",
    name: "X55Ni40-Ultra",
    component: () => import("../views/NonMagneticAlloy/NonMagneticAlloy.vue"),
    meta: {
      metaInfo: {
        title: "Non-Magnetic Alloy X55Ni40-Ultra - Fusteel Co., Ltd.",
        keywords:
          "zero magnetic alloy, non-magnetic alloy, X55Ni40-Ultra alloy, high strength zero magnetic alloy, ultra-low magnetic permeability alloy, semiconductor equipment alloy, cryogenic alloy",
        description:
          "Non-Magnetic Alloy:X55Ni40-Ultra developed by Fusteel Co., Ltd. is a flagship high-strength zero-magnetic alloy designed for extreme electromagnetic environments. Through proprietary heat treatment technology, X55Ni40-Ultra achieves hardness above HRC 52 and tensile strength exceeding 1,600 MPa without cold working, while maintaining ultra-low magnetic permeability and zero residual magnetism. The alloy is widely used in semiconductor manufacturing equipment, precision instruments, vacuum systems, and advanced engineering applications requiring excellent magnetic stability, high strength, corrosion resistance and dimensional accuracy."
      }
    },
  },
  {
    path: "/stainless-steel-rebar",
    name: "Stainless-steel-rebar",
    component: () => import("../views/StainlessSteelRebar/StainlessSteelRebar.vue"),
    meta: {
      metaInfo: {
        title: "Stainless Steel Rebar-Fusteel Co., Ltd.",
        keywords: "stainless steel rebar",
        description: "Stainless steel rebar:Fusteel(also searched as FusteelX) is the largest stainless steel rebar manufacturer in the world.We will provide the best stanless steel rebars for client.Our products satisfy BS 6744 and ASTM A955/A955M standards.We offers variable stainless steel products such as rebar, dowels, mesh and coupler.Full range of diameters from 8mm to 50mm. "
      }

    },
  },

  {
    path: "/stainless-steel-strand",
    name: "Stainless-steel-strand",
    component: () => import("../views/StainlessSteelStrand/StainlessSteelStrand.vue"),
    meta: {
      metaInfo: {
        title: "Stainless Steel Strand-Fusteel Co., Ltd.",
        keywords: "stainless steel strand",
        description: "Stainless steel strand:Fusteel(also searched as FusteelX) stainless steel strand is the world first steel strand made of duplex stainless steel with super corrosion resistance property, tensile strength grade of 1860 Mpa and low relaxation."
      }
    },
  },
  {
    path: "/cryogenic-rebar",
    name: "Cryogenic Rebar",
    component: () => import("../views/LowTemperature/LowTemperature.vue"),
    meta: {
      metaInfo: {
        title: "Cryogenic Rebar-Fusteel Co., Ltd.",
        keywords: "Cryogenic Rebar",
        description: "Cryogenic Rebar:Fusteel(also searched as FusteelX) Cryogenic Rebar is the world first steel strand made of duplex stainless steel with super corrosion resistance property, tensile strength grade of 1860 Mpa and low relaxation."
      }
    },
  },
  {
    path: "/dowel-bar",
    name: "dowel bar",
    component: () => import("../views/StainlessSteelDowelBar/StainlessSteelDowelBar.vue"),
    meta: {

      metaInfo: {
        title: "Stainless Steel Dowel Bar-Fusteel Co., Ltd.",
        keywords: "stainless steel dowel bar",
        description: "Stainless steel dowel bar:Fusteel(also searched as FusteelX) Co., Ltd. provides the best in product, service and support for all of your dowel bar needs.And we have both stainless steel dowel bar and epoxy coated dowel bar."
      }
    }
  },
  {
    path: "/pt-bar",
    name: "pt bar",
    component: () => import("../views/PtBar/PtBar.vue"),
    meta: {
      metaInfo: {
        title: "Stainless Steel Post-Tensioning Bar-Fusteel Co., Ltd.",
        keywords: "stainless steel post-tensionging bar",
        description: "The FUSTEELX stainless steel post-tensioning system is engineered from heat-treated 17-4PH stainless steel,ensuring exceptional strength exceeding 1030MPa."
      }
    }
  },
  {
    path: "/epoxy-coated-rebar",
    name: "epoxy coated rebar",
    component: () => import("../views/EpoxyCoated/EpoxyCoated.vue"),
    meta: {
      metaInfo: {
        title: "Epoxy Coated-Fusteel Co., Ltd.",
        keywords: "Epoxy Coated Rebar",
        description: "The FUSTEELX Epoxy Coated Rebar is produced by applying an epoxy resin protective coating to the surface of ordinary steel bars using an electrostatic powder spraying and high-temperature fusion bonding process. This coating exhibits excellent resistance to chemical corrosion and does not react with acids or alkalis. Furthermore, the coating is impermeable, thus delaying contact between corrosive media (such as water, oxygen, and chlorides) and the steel bars, significantly extending their corrosion resistance lifespan."
      }
    }
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products/Products.vue"),
    meta: {
      metaInfo: {
        title: "Products-Fusteel Co., Ltd.",
        keywords: "stainless steel products",
        description: "Stainless steel products: Fusteel(also searched as FusteelX) provides the highest quality service and provides the best stainless steel bars, steel strands, dowel bars and so on"
      }
    },
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("../views/AboutUs/AboutUs.vue"),
    meta: {
      metaInfo: {
        title: "About Us-Fusteel Co., Ltd.",
        keywords: "about Fusteel",
        description: "About: Fusteel(also searched as FusteelX)  Co., Ltd. is the leader of long steel procuts since 1991.We have the advantage of mill direct sale,one-step solution and accelerated delivery.We produce 2,000,000 tons high performance special steel per year,and we have absolute strength to sove various needs of customers."
      }
    }
  },
  {
    path: "/sma",
    name: "Sma",
    component: () => import("../views/SMA/Sma.vue"),
    meta: {
      metaInfo: {
        title: "SMA-Fusteel Co., Ltd.",
        keywords: "Fe-Shape Memory Materials",
        description: "Fe-Shape Memory Materials: Shape memory alloys are a unique class of alloys that have ability to 'remember' their shape and are able to return to that shape even after being bent.And Fusteel provides the best Fe-shape memory materials products"
      }
    }
  },
  {
    path: "/non-magnetic",
    name: "non-Magnetic",
    component: () => import("../views/NonMagnet/MagnetFree.vue"),
    meta: {
      metaInfo: {
        title: "Non-Magnetic-Fusteel Co., Ltd.",
        keywords: "Non-Magnetic steel",
        description: "Non-Magnetic steel: Common nonmagnetic steels in the industry include nonmagnetic structural steel and nonmagnetic stainless steel, such as 45Mn17Al3, whose remanence rate is usually 1000nT.Fusteel Non-magnet steel rebars have a remanence rate lower than 1nT. They are special nonmagnetic steels designed for extremely stringent remanence requirements and extremely weak magnetic field environments."
      }
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/ContactUs/Contact.vue"),
    meta: {

      metaInfo: {
        title: "Contact-Fusteel Co., Ltd.",
        keywords: "contact",
        description: "Contact:How to contact us.And we will reply you within 12 hours."
      }
    },
  },
  {
    path: "/careers",
    name: "Careers",
    component: () => import("../views/Careers/Careers.vue"),
    meta: {
      metaInfo: {
        title: "Careers-Fusteel Co., Ltd.",
        keywords: "careers",
        description: "Careers: Join our team and be part of the Fusteel family."
      }
    },
  },
  // {
  //   path: "/non-magnetic-strand",
  //   name: "Non-Magnetic Strand",
  //   component: () => import("../views/NonMagneticStrand/NonMagneticStrand.vue"),
  //   meta: {
  //     metaInfo: {
  //       title: "Non-Magnetic Strand-Fusteel Co., Ltd.",
  //       keywords: "non-magnetic strand",
  //       description: "Non-Magnetic Strand: Fusteel Co., Ltd. (also searched as FusteelX) produces high-performance non-magnetic steel strands for various applications."
  //     }
  //   },
  // },
  {
    path: '/download/:name',
    name: "download",
    component: () => import("../views/Uploads.vue"),
    meta: {
      metaInfo: {
        title: "Download-Fusteel Co., Ltd.",
        keywords: "Fusteel Production pdf and description",
        description: "downloading files: Fusteel Co., Ltd. (also searched as FusteelX) is the leader of long steel procuts since 1991.We have the advantage of mill direct sale,one-step solution and accelerated delivery.We produce 2,000,000 tons high performance special steel per year,and we have absolute strength to sove various needs of customers."
      }
    }
  },
  {
    path: "/warranty_book",
    name: "warranty book",
    component: () => import("../views/WarrantyBook.vue"),
    meta: {
      metaInfo: {
        title: "电子质保书平台-Fusteel Co., Ltd.",
        keywords: "电子 线上 质保书",
        description: "该页面为FusteelX电子质保书平台，用于展示产品质保书。"
      }
    }
  },
  // {
  //   path: "/question",
  //   name: "question",
  //   component: () => import("../views/Question.vue"),
  //   meta: {
  //     metaInfo: {
  //       title: "QA-Fusteel Co., Ltd.",
  //       keywords: "QA Fusteel rebar dowelbar",
  //       description: "QA: Fusteel Co., Ltd. is the leader of long steel procuts since 1991.We have the advantage of mill direct sale,one-step solution and accelerated delivery.We produce 2,000,000 tons high performance special steel per year,and we have absolute strength to sove various needs of customers."
  //     }
  //   }
  // },
  {
    path: '/:catchAll(.*)',
    redirect: '/home'
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.meta.metaInfo) {
    document.title = to.meta.metaInfo.title
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.metaInfo.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.metaInfo.description)
  }
  next();
});

export default router
